import { render, staticRenderFns } from "./SavedCandidatures.vue?vue&type=template&id=22188cf2&"
import script from "./SavedCandidatures.vue?vue&type=script&lang=js&"
export * from "./SavedCandidatures.vue?vue&type=script&lang=js&"
import style0 from "./SavedCandidatures.vue?vue&type=style&index=0&id=22188cf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports